import { LeagueLogo } from "@/components/league";

import { LeagueSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type LeagueSearchItemViewProps = {
  item: LeagueSearchItem;
};

export const LeagueSearchItemView = ({ item }: LeagueSearchItemViewProps) => {
  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <LeagueLogo league={item.league} width={30} height={30} />
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.league.title}</SearchItemLabel>
          <SearchItemDescription>DATA / Leagues</SearchItemDescription>
        </div>
      </div>
      <div className="flex items-center shrink-0 gap-1">
        <GlobalSearchItemTypeChip type="league" />
      </div>
    </div>
  );
};
